/**
 * `https://wa.me/<digits>?text=<encoded>` — the number comes from `SiteSetting contact.whatsappNumber`
 * (never hard-coded in components).
 */
export function whatsappLink(number: string, text?: string): string {
  const digits = number.replace(/\D/g, '');
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

export interface ProductMessageInput {
  name: string;
  sku: string;
  /** Absolute URL of the product page. */
  url: string;
}

/**
 * Pre-filled chat message about one stone: a greeting, the stone's name and item code, a clear ask
 * (price, sizes, finish) and the page address, so the team knows at once what the visitor saw.
 * The item code keeps the label the site uses for it ("Item code").
 */
export function productWhatsAppMessage({ name, sku, url }: ProductMessageInput): string {
  return `Hello Shree Balaji Granites! I like ${name} (Item code: ${sku}) for my project. Please share the price, sizes and finish options.\n${url}`;
}

export const whatsappAriaLabel = (productName: string): string =>
  `Chat on WhatsApp about ${productName}`;
